import { apiInfo } from '@/api/login';
import { createStore } from 'vuex'
let userLoadPromise: any = null;

interface RootState {
  path: string
  name: string
}

interface Breadcrumb {
  path: string
  name: string
  grade: number
}

interface UserInfo {
  customer_type?: number
  err_count?: number
  i_type?: number
  id: number
  is_supper: number
  name: string
  phone: string
  system?: string
}

interface UserRoles {
  id: number
  name: string
  permissions: string
  system: string
}

interface User {
  enterprise_name: string
  info: UserInfo
  roles: UserRoles[] | null
  version: number
}

export default createStore({
  state: {
    navigationArr: [] as RootState[],
    breadcrumbArr: [] as Breadcrumb[],
    userInfo: null as User | null,
    roles: [] as UserRoles[],
    loaded: false
  },
  getters: {
  },
  mutations: {
    clearUser(state) {
      state.userInfo = null;
      state.roles = [];
      state.loaded = false;
      userLoadPromise = null;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setRoles(state, roles) {
      state.roles = roles;
    },
    setLoaded(state, status) {
      state.loaded = status;
    },
    /**
     * 设置顶部导航
     * @param state state
     * @param data 导航对象
     */
    setNavigationArr(state, data) {
      const temp = state.navigationArr.find((item) => item.path === data.path);
      if (!temp) {
        state.navigationArr.push({
          path: data.path,
          name: data.meta.title
        });
      }
    },
    delNavigation(state, index) {
      state.navigationArr.splice(index, 1);
    },
    setBreadcrumb(state, data) {
      if (data.meta.grade == 1) {
        state.breadcrumbArr = [{
         name: data.meta.title,
         path: data.path,
         grade: data.meta.grade
        }];
      } else {
        state.breadcrumbArr.push({
          name: data.meta.title,
          path: data.path,
          grade: data.meta.grade
        });
      }
    },
    clear(state) {
      state.navigationArr = [];
      state.breadcrumbArr = [];
    }
  },
  actions: {
    loadUser({ commit, state }) {
      if (state.loaded) return Promise.resolve();
      if (!userLoadPromise) {
        userLoadPromise = apiInfo().then(res => {
          window.localStorage.setItem('v3userInfo', JSON.stringify(res.data));
          commit('setUserInfo', res.data);
          commit('setRoles', res.data.roles || []);
          commit('setLoaded', true);
        });
      }
      return userLoadPromise;
    }
  },
  modules: {
  }
})
